import { characters } from "@/mocks/home";
import SectionHeading from "./SectionHeading";

export default function CharactersSection() {
  return (
    <section id="characters" className="w-full bg-background-100 px-4 md:px-8 py-16 md:py-24">
      <div className="max-w-6xl mx-auto">
        <SectionHeading
          eyebrow="人物与关系"
          title="“岳母”不只是一个标签"
          desc="优秀的作品会把这位角色写成一个具体的人，而不是一个符号。熟悉常见的角色原型与她们各自的冲突来源，能帮你在阅读时更快抓住故事主线。"
        />

        <div className="mt-10 md:mt-14 grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-6">
          {characters.map((c) => (
            <article
              key={c.name}
              className="rounded-lg bg-background-50 border border-background-200/70 p-5 md:p-7 flex gap-4 md:gap-6"
            >
              <span className="shrink-0 w-14 h-14 rounded-full bg-secondary-100 text-secondary-700 flex items-center justify-center">
                <i className={`${c.icon} text-2xl`}></i>
              </span>
              <div className="flex-1">
                <div className="flex items-center gap-2 flex-wrap">
                  <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-950">
                    {c.name}
                  </h3>
                  <span className="px-2.5 py-0.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium whitespace-nowrap">
                    {c.tag}
                  </span>
                </div>
                <p className="mt-3 text-sm text-foreground-600 leading-relaxed">{c.desc}</p>
                <div className="mt-4 rounded-md bg-accent-50 border border-accent-200/70 p-3.5">
                  <p className="flex items-start gap-2 text-sm text-accent-900 leading-relaxed">
                    <i className="ri-link-m mt-0.5 shrink-0"></i>
                    <span>{c.conflict}</span>
                  </p>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}